// ./client/src/config.js

// Frontend-specific or shared config

// General Display Settings
export const SHOUT_COUNT = 10; // Number of shouts to display at once on homescreen

// Create New Shout Module Settings

// Content Type Toggles
export const ENABLE_CONTENT_TYPE_TEXT = true;   // TRUE turns on text content in New Shout Modal
export const ENABLE_CONTENT_TYPE_VIDEO = true;  // TRUE turns on video content in New Shout Modal
export const ENABLE_CONTENT_TYPE_IMAGE = false; // TRUE turns on image content in New Shout Modal
export const ENABLE_CONTENT_TYPE_POLL = true;   // TRUE turns on poll content in New Shout Modal

// Text Content Specifics
export const TEXT_COLOR_MODE = 'custom';        // 'custom' (user picks from theme), 'selected' (uses theme color), 'white'
export const MESSAGE_MAX_WORDS = 350;           // Dictates the number of words allowed in messages

// Headline Specifics
export const HEADLINE_MAX_CHARS = 100;          // Dictates the number of characters allowed in headlines

// Image Content Specifics (if ENABLE_CONTENT_TYPE_IMAGE is true)
export const DEFAULT_PLACEHOLDER_IMAGE = '/api/placeholder/800/500'; // Default placeholder image URL

// Poll Content Specifics (if ENABLE_CONTENT_TYPE_POLL is true)
export const MIN_POLL_OPTIONS = 2;              // Minimum number of options required for a poll
export const MAX_POLL_OPTIONS = 4;              // Maximum number of options allowed for a poll
export const MAX_POLL_OPTION_TEXT_LENGTH = 60; // Maximum character length for each poll option's text

// Note: Some backend configurations (like DURATION_MIN_SECONDS, MAX_DURATION_SECONDS, etc.)
// are in server/src/config.js and might influence perceived behavior but are not directly
// controlled by this client-side config file.
